import { post } from "@/utils/utils";

const memberSystem = {
  state: {
    labelSystemList: {},
    alllabelSystemList: {},
    memberGroupList: {},
    allMemberGroupList: {}
  },
  mutations: {
    QUERY_LABEL_SYSTEM_LIST(state, data) {
      state.labelSystemList = data.result;
    },
    QUERY_ALL_LABEL_SYSTEM_LIST(state, data) {
      state.alllabelSystemList = data.result;
    },
    ADD_LABEL(state, data) {
      state.addLabel = data.result;
    },
    LABEL_DETAILS(state, data) {
      state.detailsLabel = data.result;
    },
    LABEL_EDIT(state, data) {
      state.editLabel = data.result;
    },
    QUERY_MEMBER_GROUP_LIST(state, data) {
      state.memberGroupList = data.result;
    },
    QUERY_ALL_MEMBER_GROUP_LIST(state, data) {
      state.allMemberGroupList = data.result;
    },
    ADD_GROUP(state, data) {
      state.addgrop = data.result;
    },
    DETAIL_GROUP(state, data) {
      state.detailgrop = data.result;
    },
    EDIT_GROUP(state, data) {
      state.editgrop = data.result;
    },
    QUERY_LABEL_MEMEBER_LIST() {},
    QUERY_ALL_LABEL_MEMEBER_LIST() {},
    ADD_LABEL_GROUP() {},
    EDIT_LABEL_GROUP() {},
    QUERY_LABEL_GROUP_LIST() {},
    DELETE_LABEL_GROUP() {},
    QUERY_GROUP_DETAIL_LABEL_LIST() {},
    QUERY_HAS_LABEL_LIS() {},
    SAVE_BATCH_LABEL_TO_GROUP() {},
  },
  actions: {
    //标签管理列表
    queryLabelSystemList({ commit }, params) {
      return post({
        commit,
        url: `/clusterGoods/storeMemberLabelInfo/list`,
        name: "QUERY_LABEL_SYSTEM_LIST",
        params
      });
    },
    //新增标签
    addLabel({ commit }, params) {
      return post({
        commit,
        url: `/clusterGoods/storeMemberLabelInfo/add`,
        name: "ADD_LABEL",
        params
      });
    },
    //标签详情
    queryLabelDetail({ commit }, params) {
      return post({
        commit,
        url: `/clusterGoods/storeMemberLabelInfo/query_by_id`,
        name: "LABEL_DETAILS",
        params
      });
    },
    //编辑标签
    editLabel({ commit }, params) {
      return post({
        commit,
        url: `/clusterGoods/storeMemberLabelInfo/edit`,
        name: "LABEL_EDIT",
        params
      });
    },
    //导出标签管理列表
    queryALLLabelSystemList({ commit }, params) {
      return post({
        commit,
        url: `/clusterGoods/storeMemberLabelInfo/list`,
        name: "QUERY_ALL_LABEL_SYSTEM_LIST",
        params
      });
    },
    //群组管理列表
    queryMemberGroupList({ commit }, params) {
      return post({
        commit,
        url: `/clusterGoods/storeGroupInfo/list`,
        name: "QUERY_MEMBER_GROUP_LIST",
        params
      });
    },
    //群组管理列表
    queryAllMemberGroupList({ commit }, params) {
      return post({
        commit,
        url: `/clusterGoods/storeGroupInfo/list`,
        name: "QUERY_ALL_MEMBER_GROUP_LIST",
        params
      });
    },
    //新增群组
    addGroup({ commit }, params) {
      return post({
        commit,
        url: `/clusterGoods/storeGroupInfo/add`,
        name: "ADD_GROUP",
        params
      });
    },
    //群组详情
    queryGroupDetail({ commit }, params) {
      return post({
        commit,
        url: `/clusterGoods/storeGroupInfo/queryById`,
        name: "DETAIL_GROUP",
        params
      });
    },
    //编辑群组
    editGroup({ commit }, params) {
      return post({
        commit,
        url: `/clusterGoods/storeGroupInfo/edit`,
        name: "EDIT_GROUP",
        params
      });
    },
    queryLabelMemberList({ commit }, params) {
      return post({
        commit,
        url: `/clusterGoods/storeMemberLabelInfo/queryMemberList`,
        name: "QUERY_LABEL_MEMEBER_LIST",
        params
      });
    },
    queryAllLabelMemberList({ commit }, params) {
      return post({
        commit,
        url: `/clusterGoods/storeMemberLabelInfo/queryMemberList`,
        name: "QUERY_ALL_LABEL_MEMEBER_LIST",
        params
      });
    },
    addLabelGroup({ commit }, params) {
      return post({
        commit,
        url: `/labelGroup/add`,
        name: "ADD_LABEL_GROUP",
        params
      });
    },
    editLabelGroup({ commit }, params) {
      return post({
        commit,
        url: `/labelGroup/edit`,
        name: "EDIT_LABEL_GROUP",
        params
      });
    },
    queryLabelGroupList({ commit }, params) {
      return post({
        commit,
        url: `/labelGroup/queryPageList`,
        name: "QUERY_LABEL_GROUP_LIST",
        params
      });
    },
    deleteLabelGroup({ commit }, params) {
      return post({
        commit,
        url: `/labelGroup/delete`,
        name: "DELETE_LABEL_GROUP",
        params
      });
    },
    queryGroupDetailLabelList({ commit }, params) {
      return post({
        commit,
        url: `/labelGroup/queryById`,
        name: "QUERY_GROUP_DETAIL_LABEL_LIST",
        params
      });
    },
    deleteLabelGroupToGroup({ commit }, params) {
      return post({
        commit,
        url: `/labelGroup/delete/label?groupId=` + params.groupId + '&labelId=' + params.labelId,
        name: "QUERY_GROUP_DETAIL_LABEL_LIST",
        params
      });
    },
    queryHasLabelLis({ commit }, params) {
      return post({
        commit,
        url: `/labelGroup/pre/add`,
        name: "QUERY_HAS_LABEL_LIS",
        params
      });
    },
    saveBatchLabelToGroup({ commit }, params) {
      return post({
        commit,
        url: `/clusterGoods/storeMemberLabelInfo/batch/add`,
        name: "SAVE_BATCH_LABEL_TO_GROUP",
        params
      });
    },
  }
};

export default memberSystem;
